import FilterIcon from "../../../../icons/FilterIcon";
import ChevronDownIcon from "../../../../icons/ChevronDownIcon";
import {
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from "../../../../popover/Popover";
import { ConfigKursusGruppe } from "../../../../../constants/config";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IKundenummerFilterNrType, KursusFilterState } from "./KursusDeltagere";
import { ComboBox } from "../../../../filter/ComboBox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../../../select/Select";
import AppliedFilterItem from "../../../../filter/AppliedFilterItem";
import CloseIcon from "../../../../icons/CloseIcon";
import { DatePicker as RSDatePicker } from "rsuite";
import { splitPickerChange } from "../../../../formcontrols/datePickerValue";

const DeltagerFiltre = ({
  filter,
  setFilter,
  setSelectedIds,
}: {
  filter: KursusFilterState;
  setFilter: Dispatch<SetStateAction<KursusFilterState>>;
  setSelectedIds: Dispatch<SetStateAction<string[]>>;
}) => {
  const [kundenummer, setKundenummer] = useState({
    type: "Lig med",
    input: "",
    input2: "",
  } as { type: IKundenummerFilterNrType; input: string; input2?: string });
  // Unfinished dates, kept on screen while the filter holds null (ADV-320).
  const [drafts, setDrafts] = useState<{
    date: Date | null;
    date2: Date | null;
  }>({ date: null, date2: null });
  useEffect(() => setSelectedIds([]), [filter, setSelectedIds]);
  const countNonNullableKeys = (filter: KursusFilterState) => {
    let count = 0;
    if (filter.nr.length > 0) {
      count++;
    }
    if (filter.date.date !== null) {
      if (filter.date.type === "Mellem") {
        if (filter.date.date2) count++;
      } else {
        count++;
      }
    }
    if (filter.groups.length > 0) {
      count++;
    }
    return count;
  };
  const filterCount = countNonNullableKeys(filter);
  return (
    <PopoverRoot>
      <PopoverTrigger asChild>
        <button type="button" className="btn btn--action">
          <FilterIcon height={14} /> Filtre{" "}
          {filterCount > 0 && (
            <>
              <span className="badge rounded-pill">{filterCount}</span>{" "}
            </>
          )}
          <ChevronDownIcon />
        </button>
      </PopoverTrigger>

      <PopoverContent className="p-0 align-items-stretch gap-0">
        <h5 className="p-3 border-bottom">Filtrer efter</h5>
        <div className="p-3 border-bottom">
          <label className="form-label">Status</label>
          <div
            className="c-applied-filter-group d-grid gap-2"
            style={{ gridTemplateColumns: "1fr 1fr" }}
          >
            <label className="d-flex gap-2 align-items-center">
              <input
                className="form-check-input mt-0"
                type="checkbox"
                checked={filter.status.includes("TILMELDT")}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFilter(
                    checked && !filter.status.includes("TILMELDT")
                      ? { ...filter, status: [...filter.status, "TILMELDT"] }
                      : {
                          ...filter,
                          status: filter.status.filter((s) => s !== "TILMELDT"),
                        },
                  );
                }}
              />
              <span className="">Tilmeldt</span>
            </label>
            <label className="d-flex gap-2 align-items-center">
              <input
                className="form-check-input mt-0"
                type="checkbox"
                checked={filter.status.includes("AFMELDT")}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFilter(
                    checked && !filter.status.includes("AFMELDT")
                      ? { ...filter, status: [...filter.status, "AFMELDT"] }
                      : {
                          ...filter,
                          status: filter.status.filter((s) => s !== "AFMELDT"),
                        },
                  );
                }}
              />
              <span className="">Afmeldt</span>
            </label>
          </div>
        </div>
        <div className="p-3 border-bottom">
          <label className="form-label">Kundenummer</label>
          <div className="c-applied-filter-group">
            {filter.nr.map((nr) => {
              return (
                <AppliedFilterItem
                  key={nr.type + " " + nr.input}
                  label={nr.input}
                  labelPrefix={nr.type}
                  removeFilterHandler={() =>
                    setFilter({
                      ...filter,
                      date: filter.date,
                      groups: filter.groups,
                      nr: filter.nr.filter(
                        (e) => !(e.input === nr.input && e.type === nr.type),
                      ),
                    })
                  }
                />
              );
            })}
          </div>
          <ComboBox>
            <Select
              defaultValue="Lig med"
              value={kundenummer.type}
              onValueChange={(value) =>
                setKundenummer({
                  input: kundenummer.input,
                  type: value as IKundenummerFilterNrType,
                  input2: kundenummer.input2,
                })
              }
            >
              <SelectTrigger aria-label="Vælg filterfunktion" badge />
              <SelectContent small>
                <SelectItem value="Lig med">Lig med</SelectItem>
                <SelectItem value="Mindre end">Mindre end</SelectItem>
                <SelectItem value="Større end">Større end</SelectItem>
                <SelectItem value="Mellem">Mellem</SelectItem>
              </SelectContent>
            </Select>
            <input
              className="form-control"
              type="number"
              placeholder="Kundenummer"
              required
              onChange={(e) =>
                setKundenummer({
                  type: kundenummer.type,
                  input: e.target.value,
                  input2: kundenummer.input2,
                })
              }
              value={kundenummer.input}
            />
            {kundenummer.type === "Mellem" && (
              <>
                -{" "}
                <input
                  className="form-control"
                  type="number"
                  placeholder="Kundenummer"
                  required
                  onChange={(e) =>
                    setKundenummer({
                      type: kundenummer.type,
                      input: kundenummer.input,
                      input2: e.target.value,
                    })
                  }
                />
              </>
            )}
            <button
              aria-label="Anvend"
              className={`btn btn-primary btn--sm py-1 me-n1 btn--combo-action`}
              onClick={() => {
                setFilter({
                  ...filter,
                  date: filter.date,
                  groups: filter.groups,
                  nr: [
                    ...filter.nr,
                    kundenummer.type === "Mellem"
                      ? {
                          type: kundenummer.type,
                          input: kundenummer.input + " - " + kundenummer.input2,
                        }
                      : { type: kundenummer.type, input: kundenummer.input },
                  ],
                });
                setKundenummer({
                  type: "Lig med",
                  input: "",
                  input2: undefined,
                });
              }}
            >
              OK
            </button>
          </ComboBox>
        </div>
        <div className="p-3 border-bottom">
          <label className="form-label">Tilmeldingsdato</label>
          <ComboBox>
            <Select
              defaultValue="Mellem"
              value={filter.date.type}
              onValueChange={(value) =>
                setFilter({
                  ...filter,
                  date: {
                    ...filter.date,
                    type: value as "Mellem" | "Før" | "Efter",
                  },
                })
              }
            >
              <SelectTrigger aria-label="Vælg datotype" badge />
              <SelectContent small>
                <SelectItem value="Mellem">Mellem</SelectItem>
                <SelectItem value="Før">Før</SelectItem>
                <SelectItem value="Efter">Efter</SelectItem>
              </SelectContent>
            </Select>
            <RSDatePicker
              className={filter.date.type === "Mellem" ? "flex-grow-0" : ""}
              appearance="subtle"
              cleanable={false}
              format="dd.MM.yyyy"
              oneTap
              size="xs"
              onChange={(date) => {
                const next = splitPickerChange(date);
                setDrafts((current) => ({ ...current, date: next.draft }));
                setFilter({
                  ...filter,
                  date: { ...filter.date, date: next.value },
                });
              }}
              value={filter.date.date ?? drafts.date}
            />
            {filter.date.type === "Mellem" && (
              <>
                <>-</>
                <RSDatePicker
                  className="flex-grow-0"
                  appearance="subtle"
                  cleanable={false}
                  format="dd.MM.yyyy"
                  oneTap
                  size="xs"
                  onChange={(date) => {
                    const next = splitPickerChange(date);
                    setDrafts((current) => ({ ...current, date2: next.draft }));
                    setFilter({
                      ...filter,
                      date: { ...filter.date, date2: next.value },
                    });
                  }}
                  value={filter.date.date2 ?? drafts.date2}
                />
              </>
            )}
            {(filter.date.date || filter.date.date2) && (
              <button
                aria-label="Nulstil"
                className={`btn btn-secondary btn--transparent btn--icon btn--sm flex-shrink-0 ms-auto`}
                onClick={() => {
                  setDrafts({ date: null, date2: null });
                  setFilter({
                    ...filter,
                    date: { ...filter.date, date: null, date2: null },
                  });
                }}
              >
                <CloseIcon height={16} width={16} />
              </button>
            )}
          </ComboBox>
        </div>
        <div className="p-3 border-bottom">
          <h6 className="form-label mb-3">Gruppe</h6>
          <div
            className="d-grid gap-2"
            style={{ gridTemplateColumns: "1fr 1fr" }}
          >
            {Object.values(ConfigKursusGruppe.badge.className).map(
              (className, i) => (
                <div className="form-check" key={"gruppe " + (i + 1)}>
                  <label className="d-flex gap-2 align-items-center">
                    <input
                      className="form-check-input mt-0"
                      type="checkbox"
                      checked={filter.groups.includes(i + 1)}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setFilter(
                          checked
                            ? { ...filter, groups: [...filter.groups, i + 1] }
                            : {
                                ...filter,
                                groups: filter.groups.filter(
                                  (num) => num !== i + 1,
                                ),
                              },
                        );
                      }}
                    />
                    <span className={className}>Gruppe {i + 1}</span>
                  </label>
                </div>
              ),
            )}
          </div>
        </div>
      </PopoverContent>
    </PopoverRoot>
  );
};

export default DeltagerFiltre;
